import React from 'react';

import { GenreSimplifieFormValue } from '../types';

import { useModalCreate } from './hooks';
import ModalEdition from './ModalEdition';

interface ModalCreateProps {
  close: () => void;
  visible: boolean;
  refreshDashboard: () => void;
}

export default function ModalCreate({
  close,
  visible,
  refreshDashboard,
}: ModalCreateProps): React.ReactElement {
  const initials: GenreSimplifieFormValue = {};
  const { submit, inProgress, validate } = useModalCreate(
    refreshDashboard,
    close,
  );

  return (
    <ModalEdition
      close={close}
      visible={visible}
      title="Créer un genre simplifié"
      initials={initials}
      isSubmitting={inProgress}
      submit={submit}
      validate={validate}
    />
  );
}
